import { useEffect, useRef, useState } from "react";

export default function useCircleLayout(members) {
    const containerRef = useRef(null);
    const [avatarStyles, setAvatarStyles] = useState([]);

    useEffect(() => {
        if (!containerRef.current || members.length === 0) return;

        const center = containerRef.current.offsetWidth / 2;

        const layouts = {
            1: [{ x: 0, y: 50, size: 240 }],
            2: [
                { x: 0, y: -15, size: 180 },
                { x: 0, y: 160, size: 180 }
            ],
            3: [
                { x: 0, y: -15, size: 180 },
                { x: -80, y: 140, size: 160 },
                { x: 80, y: 140, size: 160 }
            ],
            4: [
                { x: 0, y: -25, size: 160 },
                { x: 105, y: 87, size: 150 },
                { x: -105, y: 87, size: 150 },
                { x: 0, y: 185, size: 140 }
            ],
            5: [
                { x: 0, y: -25, size: 150 },
                { x: -115, y: 60, size: 140 },
                { x: 115, y: 60, size: 140 },
                { x: -65, y: 185, size: 130 },
                { x: 65, y: 185, size: 130 }
            ]
        };

        const layout = layouts[members.length] || [];

        const styles = members.map((_, i) => {
            const pos = layout[i] || { x: 0, y: 0, size: 60 };
            return {
                position: "absolute",
                top: `${center + pos.y - pos.size / 2}px`,
                left: `${center + pos.x - pos.size / 2}px`,
                width: `${pos.size}px`,
                height: `${pos.size}px`,
                zIndex: 10 - i
            };
        });

        setAvatarStyles(styles);
    }, [members]);

    return { containerRef, avatarStyles };
}
